import React from "react";
import { Form, Row, Col, Input, InputNumber } from "antd";
import moment from "moment";
import Datepicker from "../toolbox/DatePicker";
import KasaSelectOption from "../toolbox/KasaSelectOption";
import BankaHesapSelectOption from "../toolbox/BankaHesapSelectOption";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import OdemeSekliSelectOption from "../toolbox/OdemeSekliSelectOption";
import { odemeSekliTypes } from "../../types/odemeSekliTypes";
import strings from "../../utils/Localization";
import useVarsayilanDeger from "../../hooks/useVarsayilanDeger";

export default function TahsilatOdemeForm({
  onFinish,
  form,
  formSize = "middle",
  id,
  dovizDisabled = false,
  initialValues = {},
}) {
  const { getDefaultSetting } = useVarsayilanDeger();
  const { tahsilatOdemeForm } = strings.cariIslem.components;
  const onValuesChange = (changedValues, allValues) => {
    if (changedValues.dovizId !== undefined) {
      form.setFieldsValue({
        kasaId: null,
        bankaHesapId: null,
      });
    }
  };
  return (
    <Form
      id={id}
      form={form}
      layout="vertical"
      size="middle"
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      initialValues={{
        islemTarihi: moment(),
        evrakNo: "",
        aciklama: "",
        dovizId: getDefaultSetting("doviz"),
        odemeSekli: getDefaultSetting("odemeSekli"),
        tutar: 0,
        ...initialValues,
      }}
    >
      <Row gutter={24}>
        <Col flex={1}>
          <Form.Item
            label={tahsilatOdemeForm.islemTarihi}
            name="islemTarihi"
            rules={[{ required: true }]}
          >
            <Datepicker size={formSize} />
          </Form.Item>
          <Form.Item label={tahsilatOdemeForm.evrakNo} name="evrakNo" required>
            <Input />
          </Form.Item>
          <Form.Item label={tahsilatOdemeForm.aciklama} name="aciklama">
            <Input.TextArea rows={5} placeholder={""} />
          </Form.Item>
        </Col>
        <Col flex={1}>
          <DovizSelectOption
            formItemName="dovizId"
            size={formSize}
            required
            disabled={dovizDisabled}
          />
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.dovizId !== currentValues.dovizId
            }
          >
            {({ getFieldValue }) => {
              const currentDovizId = getFieldValue("dovizId");
              if (currentDovizId !== null) {
                return (
                  <OdemeSekliSelectOption
                    formItemName="odemeSekli"
                    formItemLabel={tahsilatOdemeForm.odemeSekli}
                    required
                    size={formSize}
                    hiddenAcikHesap
                  />
                );
              }
            }}
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.odemeSekli !== currentValues.odemeSekli ||
              prevValues.dovizId !== currentValues.dovizId
            }
          >
            {({ getFieldValue }) => {
              const currentOdemeSekli = getFieldValue("odemeSekli");
              const currentDovizId = getFieldValue("dovizId");
              if (currentOdemeSekli === odemeSekliTypes.NAKIT) {
                return (
                  <KasaSelectOption
                    formItemName="kasaId"
                    formItemLabel={tahsilatOdemeForm.kasa}
                    required={true}
                    size={formSize}
                    showDovizKod
                    requestBody={{
                      Data: {
                        dovizId: currentDovizId,
                      },
                    }}
                  />
                );
              } else if (
                currentOdemeSekli === odemeSekliTypes.KREDI_KARTI ||
                currentOdemeSekli === odemeSekliTypes.HAVALE
              ) {
                return (
                  <BankaHesapSelectOption
                    formItemName="bankaHesapId"
                    formItemLabel={tahsilatOdemeForm.bankaHesap}
                    required={true}
                    size={formSize}
                    showDovizKod
                    requestBody={{
                      Data: {
                        dovizId: currentDovizId,
                      },
                    }}
                  />
                );
              }
            }}
          </Form.Item>
          <Form.Item
            label={tahsilatOdemeForm.tutar}
            name="tutar"
            rules={[{ required: true }]}
          >
            <InputNumber
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              style={{ width: "100%" }}
              min={0}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
